import React, { useRef, useEffect, useState, useMemo } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import { defineMessages, FormattedDate, useIntl } from "react-intl";
import clsx from "clsx";
import Button from "../../components/common/button/button";
import { filterTasklist } from "../../redux/tasklist/tasklistActions";
import { DatePicker } from "@material-ui/pickers";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import CalendarIcon from "../common/icons/calendarIcon";
// import DatePicker from '../common/datepicker/datePicker';
import { Divider, Drawer, makeStyles } from "@material-ui/core";
import { ChevronLeft, ChevronRight, LocalConvenienceStoreOutlined } from "@material-ui/icons";
import {
    filterDashboard,
    zonesSelected,
    allStatusDashboard,
    getAllFiltersData,
    setCreationDate,
    clearCreationDate,
    clearWorkOrderId,
} from "../../redux/dashboard/dashboardActions";
import { requestTasks, clearTasks, requestTasksSucceeded, clearTaskCounts } from "../../redux/task/taskActions";
import { stopPolling } from "../../redux/login/loginActions";
import { setSidebar, clearFilter, clearAllStatus } from "../../redux/dashboard/dashboardActions";
import HomeIcon from "../common/icons/homeIcon";
import SidebarNav from "./sidebarNav";
import SidebarNavLink from "./sidebarNavLink";
import Filter from "../common/filter/filter";
import "./sidebar.css";
import FilterProperty from "../common/filter/filterProperty";
import { useLocalizedName } from "../../globals/langHelpers";
import SidebarAccordian from "../common/accordian/sidebarAccordian";
import { ListItemText } from "@material-ui/core";
import { CustomShortDateFormatter } from "../../globals/dateFormatHelpers";

const drawerWidth = 270;
const messages = defineMessages({
    sidebarNavLinkOverviewTitle: {
        id: "sidebar.overview-title",
        defaultMessage: "Overview",
        description: "Navigation title to go to Overview page",
    },
    filterTitle: {
        id: "common-filter.filterTitle",
        defaultMessage: "Filter",
        description: "Title for filters",
    },
    sidebarNavLinkContractNameFilterTitle: {
        id: "sidebar.contract-name",
        defaultMessage: "Contract Name",
        description: "Title for filtering on contract names",
    },
    sidebarNavLinkAllStatusNameFilterTitle: {
        id: "sidebar.filter-allstatus",
        defaultMessage: "Status",
        description: "Title for filtering on status",
    },
    sidebarNavLinkZoneFilterTitle: {
        id: "sidebar.zone",
        defaultMessage: "Zone",
        description: "Title for filtering on zone",
    },
    creationStartDate: {
        id: "cmis-lab-details-label.creationStartDate",
        defaultMessage: "From",
        description: "From",
    },
    creationEndDate: {
        id: "cmis-lab-details-label.creationEndDate",
        defaultMessage: "To",
        description: "To",
    },
    sidebarNavLinkLoad: {
        id: "sidebar.filters.load",
        defaultMessage: "Load",
        description: "Load Filters",
    },
    sidebarNavLinkClear: {
        id: "sidebar.filters.clear-filters",
        defaultMessage: "Clear Filters",
        description: "Clear Filters",
    },
    creationDate: {
        id: "task-field-label.creationDate",
        defaultMessage: "Creation Date",
        description: "Creation Date",
    },
    creationDateMismatch: {
        id: "cmis-lab-details-label.creationDateMismatch",
        defaultMessage: "'From' date cannot be less than 'To' date",
        description: "'From' date cannot be less than 'To' date",
    },
});
const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: "none",
    },
    paper: {
        background: "#F4F4F4",
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: "nowrap",
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: "hidden",
        width: theme.spacing(4) + 1,
        [theme.breakpoints.up("sm")]: {
            width: theme.spacing(6) + 1,
        },
    },
    toolbar: {
        display: "flex",
        marginTop: "56px",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
    },
    btnStyle: {
        padding: "5px 25px",
    },
    searchBar: {
        "& .MuiTextField-root": {
            margin: "15px 0",
            padding: "0 10px",
            width: "100%",
        },
        "& .MuiOutlinedInput-root": {
            borderRadius: 18,
        },
        "& .MuiOutlinedInput-notchedOutline": {
            borderWidth: 2,
        },
    },
    textFieldBar: {
        fontFamily: "Arial",
        fontSize: "12px",
        fontWeight: "bold",
    },
    datePickerBg: {
        marginLeft: "13px",
        paddingTop: "2%",
        paddingLeft: "16px",
        paddingRight: "16px",
    },
    textField: {
        fontFamily: "Arial",
        fontSize: "12px",
    },
    errorMessage: {
        marginLeft: "10px",
        marginTop: "10px",
        fontSize: "12px",
        fontFamily: "Arial",
        color: "red",
        maxWidth: "150px",
        whiteSpace: "pre-wrap",
    },
    creationDatelabel: {
        color: "#555555",
        fontSize: "14px",
        fontFamily: "Arial",
        fontWeight: "700",
        paddingLeft: "16px",
        paddingRight: "16px",
    },
    listPrimary: {
        paddingLeft: 10,
        fontSize: "16px",
        fontWeight: 700,
        fontFamily: "Arial",
        color: "#555555",
    },
}));
const Sidebar = (props) => {
    const { filtering = true, open, contracts, filter, task, zones, isFetching, allStatus } = props;
    const classes = useStyles();
    const [openContract, setOpenContract] = useState(false);
    const [openStatus, setOpenStatus] = useState(false);
    const [openZone, setOpenZone] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [openCreationDate, setOpenCreationDate] = useState(false);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [clearDate, setClearDate] = useState(false);
    const STATUS_KEY = "STATUS";
    const CONTRACT_KEY = "CONTRACT";
    const isAllSelectionAllowed = process.env.REACT_APP_FEATURE_ALL_STATUS_SELECTION === "true";
    const [disableLoadButton, setDisableLoadButton] = useState(true);
    const [intervalval, setIntervalval] = useState();
    const intl = useIntl();
    const { getLocalizedName } = useLocalizedName();
    const [creationDateObject, setCreationDateObject] = useState({
        fromDate: "",
        toDate: "",
    });
    const [contractList, setContractList] = useState({
        all: false,
        items: [],
        title: "",
    });
    const [allStatusList, setAllstatusList] = useState({
        all: false,
        items: [],
        title: "",
    });
    const [title, setTitle] = useState("");
    const [isFromOpen, setIsFromOpen] = useState(false);
    const [isToOpen, setIsToOpen] = useState(false);
    const [clearContractFilter, setClearContractFilter] = useState(false);
    const [clearAllStatuses, setClearAllStatuses] = useState(false);
    const [showAllStatuses, setShowAllStatuses] = useState(false);
    const [clearSearchBar, setClearSearchBar] = useState(false);
    const [titles, setTitles] = useState([]);
    const [workOrderId, setWorkOrderId] = useState("");
    const contractNumbers = filter.items.map((item) => item.contractNumber);
    const onShowList = task.filter((task) => filter.all || contractNumbers.includes(task.contractNumber));
    const zoneData = onShowList ? onShowList.map((item) => item.zone).reduce((pre, cur) => (pre.includes(cur) ? pre : pre.concat(cur)), []) : [];
    const fromDateRef = useRef(null);
    const toDateRef = useRef(null);
    const searchBarRef = useRef(null);
    const unAssignedStatus = useMemo(() => allStatus?.find((status) => status.id === "3"), [allStatus]);

    const handleDrawerOpen = () => {
        props.setSidebar(true);
    };
    const handleDrawerClose = () => {
        props.setSidebar(false);
    };
    useEffect(() => {
        // let contractItems = props.filter;
        // let statusItems = props.dashboardStaus;
        searchBarRef.current.value = props?.dashboardState?.workOrderNumber;
        setWorkOrderId(props.dashboardState.workOrderNumber);
        setContractList(props.filter);
        setAllstatusList(props.dashboardState.allStatuses);
        let dashboardFromDate = props.dashboardcreationDateObject.fromDate;
        let dashboardToDate = props.dashboardcreationDateObject.toDate;
        setFromDate(dashboardFromDate ?? "");
        setToDate(dashboardToDate ?? "");
        setClearDate(false);
    }, []);

    const handleUpdateFilterCall = (data) => {
        if (workOrderId) {
            props.clearWorkOrderId();
            setClearSearchBar(true);
            setWorkOrderId("");
            setDisableLoadButton(true);
        }
        setTitles([...titles, data.title]);
        if (data.title === CONTRACT_KEY) {
            let filters = [...data?.items];
            let items = [...new Set(filters)];
            if (filters.length == 0 && allStatusList && allStatusList.items.length > 0) {
                setDisableLoadButton(true);
            } else if (filters.length > 0 && allStatusList && allStatusList.items.length > 0) {
                setDisableLoadButton(false);
            }
            setContractList({ all: false, items: items });
        }
        if (data.title === STATUS_KEY) {
            let filters = [...data?.items];
            let allValue = data?.all;
            let items = [...new Set(filters)];
            if (filters.length == 0 && contractList && contractList.items.length > 0) {
                setDisableLoadButton(true);
            } else if (filters.length > 0 && contractList && contractList.items.length > 0) {
                setDisableLoadButton(false);
            }
            setAllstatusList({ all: allValue, items: items });
        }
        setTitle(data?.title);
    };

    const fetchTasks = () => {
        if (
            (contractList.items.length > 0 && allStatusList.items.length > 0) ||
            (creationDateObject.fromDate !== "" && creationDateObject.toDate !== "")
        ) {
            setClearSearchBar(true);
            props.getAllFiltersData({ filter: contractList, allStatuses: allStatusList, creationDate: creationDateObject, workOrderNumber: "" });
            props.requestTasks({ fetchCounts: true, workOrderNumber: "" });
        }
        if (
            workOrderId &&
            contractList.items.length === 0 &&
            allStatusList.items.length === 0 &&
            (creationDateObject.fromDate === "" || creationDateObject.fromDate === null) &&
            (creationDateObject.toDate === "" || creationDateObject.toDate === null)
        ) {
            setContractList({ all: true, items: [] });
            setClearContractFilter(true);
            setAllstatusList({ all: false, items: [] });
            setClearAllStatuses(true);
            setFromDate(null);
            setToDate(null);
            setCreationDateObject({
                fromDate: "",
                toDate: "",
            });
            props.clearFilter();
            props.clearAllStatus();
            props.clearCreationDate();
            props.clearTaskCounts();
            props.filterTasklist({});
            setClearDate(true);
            props.getAllFiltersData({
                filter: contractList,
                allStatuses: allStatusList,
                creationDate: creationDateObject,
                workOrderNumber: workOrderId,
            });
            props.requestTasks({ fetchCounts: true, workOrderNumber: workOrderId });
        }
    };

    useEffect(() => {
        if (workOrderId && (fromDate || toDate)) {
            props.clearWorkOrderId();
            setClearSearchBar(true);
            setWorkOrderId("");
        }
        setFromDate(fromDate ?? "");
        setToDate(toDate ?? "");
        if (fromDate && toDate && fromDate > toDate) {
            setErrorMessage(intl.formatMessage(messages.creationDateMismatch));
        } else {
            setErrorMessage(null);
            setCreationDateObject({
                fromDate: fromDate,
                toDate: toDate,
            });
        }
    }, [toDate, fromDate]);

    useEffect(() => {
        if (isAllSelectionAllowed) {
            setAllstatusList({ all: true, items: [...allStatus] });
        } else {
            setAllstatusList({ all: false, items: unAssignedStatus ? [unAssignedStatus] : [] });
        }
    }, [allStatus, showAllStatuses, unAssignedStatus]);

    useEffect(() => {
        if ((contractList.items.length > 0 && allStatusList.items.length > 0) || workOrderId !== "") {
            setDisableLoadButton((fromDate !== "" && toDate === "") || (fromDate === "" && toDate !== ""));
        }
    }, [fromDate, toDate]);

    const handleChange = (e) => {
        setClearSearchBar(false);
        if (e?.target?.value) {
            setWorkOrderId(e.target.value);
            setContractList({ all: true, items: [] });
            setClearContractFilter(true);
            setAllstatusList({ all: false, items: [] });
            setClearAllStatuses(true);
            setFromDate(null);
            setToDate(null);
            setCreationDateObject({
                fromDate: "",
                toDate: "",
            });
            setDisableLoadButton(false);
        } else {
            setDisableLoadButton(true);
            setAllstatusList(isAllSelectionAllowed ? { all: true, items: [...allStatus] } : { all: false, items: [unAssignedStatus] });
        }
    };

    useEffect(() => {
        if (clearSearchBar) {
            searchBarRef.current.value = "";
        }
    }, [clearSearchBar]);

    const clearTasksCompletely = () => {
        setContractList({ all: true, items: [] });
        setClearContractFilter(true);
        //setAllstatusList({ all: false, items: []});
        setClearAllStatuses(true);
        setFromDate(null);
        setToDate(null);
        setCreationDateObject({
            fromDate: "",
            toDate: "",
        });
        props.clearTasks();
        props.clearFilter();
        props.clearAllStatus();
        props.clearCreationDate();
        props.clearTaskCounts();
        props.clearWorkOrderId();
        props.filterTasklist({});
        setClearDate(true);
        setClearSearchBar(true);
        setWorkOrderId("");
        setDisableLoadButton(true);
        //    setShowAllStatuses(true);
        setAllstatusList(isAllSelectionAllowed ? { all: true, items: [...allStatus] } : { all: false, items: [unAssignedStatus] });
    };

    return (
        <Drawer
            variant="permanent"
            className={clsx(classes.drawer, {
                [classes.drawerOpen]: open,
                [classes.drawerClose]: !open,
            })}
            classes={{
                paper: clsx(classes.paper, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                }),
            }}>
            <div className={classes.toolbar}>
                <span style={{ flex: 1 }}>
                    {open
                        ? // <FormattedDate
                          //     value={moment().toDate()}
                          //     year="numeric"
                          //     month="long"
                          //     day="numeric"
                          // /> : ''
                          moment(new Date())?.format("MMM DD, YYYY")
                        : ""}
                </span>
                <div className="sidebar-hover" onClick={open ? handleDrawerClose : handleDrawerOpen}>
                    {open ? <ChevronLeft color="primary" /> : <ChevronRight color="primary" />}
                </div>
            </div>
            <Divider />
            <SidebarNav open={open}>
                <SidebarNavLink icon={HomeIcon} caption={intl.formatMessage(messages.sidebarNavLinkOverviewTitle)} path="/" index={0} />
            </SidebarNav>
            <hr />
            <div>
                <ListItemText primary={intl.formatMessage(messages.filterTitle)} classes={{ primary: classes.listPrimary }} />
                <div className={classes.searchBar}>
                    <TextField
                        id="outlined-textarea"
                        placeholder="WO#: OWI_CMS_01234567890_0000"
                        variant="outlined"
                        margin="normal"
                        inputRef={searchBarRef}
                        onChange={handleChange}
                        InputProps={{
                            classes: {
                                input: classes.textFieldBar,
                            },
                        }}
                    />
                </div>
                {/* Contracts */}
                {filtering && open && process.env.REACT_APP_FEATURE_MANAGELABOURERS === "true" && (
                    <SidebarAccordian
                        expanded={openContract}
                        onChangeHandler={(e) => {
                            e.preventDefault();
                            setOpenContract(!openContract);
                        }}
                        required
                        headerTitle={messages.sidebarNavLinkContractNameFilterTitle.id}>
                        <Filter
                            title={intl.formatMessage(messages.sidebarNavLinkContractNameFilterTitle)}
                            filterOptions={contracts}
                            filterKeys={{
                                name: "description",
                            }}
                            inputFilter={contractList}
                            onUpdateFilter={(data) => handleUpdateFilterCall(data, "contracts")}
                            isCleared={clearContractFilter}
                            filterTitle="true"
                            titleKey={CONTRACT_KEY}
                            // useAll
                        />
                    </SidebarAccordian>
                )}

                {/* Creation Date */}
                {filtering && open && contracts && contracts.length > 0 && process.env.REACT_APP_FEATURE_MANAGELABOURERS === "true" && (
                    <SidebarAccordian
                        expanded={openCreationDate}
                        onChangeHandler={(e) => {
                            e.preventDefault();
                            setOpenCreationDate(!openCreationDate);
                        }}
                        headerTitle={messages.creationDate.id}>
                        <div>
                            {/* <label className={classes.creationDatelabel}>{intl.formatMessage(messages.creationDate)}</label> */}
                            <div className={classes.datePickerBg}>
                                <DatePicker
                                    clearable
                                    variant={"inline"}
                                    ref={fromDateRef}
                                    open={isFromOpen}
                                    onOpen={() => setIsFromOpen(true)}
                                    onClose={() => setIsFromOpen(false)}
                                    label={intl.formatMessage(messages.creationStartDate)}
                                    value={fromDate}
                                    inputFormat="MMM d, yyyy"
                                    disableFuture
                                    onChange={(e) => setFromDate(e)}
                                    renderInput={(params) => {
                                        params.inputProps.value = CustomShortDateFormatter(fromDate);

                                        return (
                                            <TextField
                                                {...params}
                                                className={classes.textField}
                                                helperText={""}
                                                placeholder={""}
                                                fullWidth
                                                InputLabelProps={{
                                                    style: { fontSize: "12px", fontFamily: "Arial", color: "rgba(0, 0, 0, 0.87)", fontWeight: "700" },
                                                }}
                                                error={false}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textField,
                                                    },
                                                    onClick: () => {
                                                        setIsFromOpen(true);
                                                    },
                                                    onKeyDown: (e) => {
                                                        e.preventDefault();
                                                        return false;
                                                    },
                                                    endAdornment: (
                                                        <IconButton onClick={() => setIsFromOpen(true)}>
                                                            <CalendarIcon />
                                                        </IconButton>
                                                    ),
                                                }}
                                            />
                                        );
                                    }}
                                />
                            </div>
                            <div className={classes.datePickerBg}>
                                <DatePicker
                                    variant={"inline"}
                                    clearable
                                    ref={toDateRef}
                                    label={intl.formatMessage(messages.creationEndDate)}
                                    value={toDate}
                                    open={isToOpen}
                                    onOpen={() => setIsToOpen(true)}
                                    onClose={() => setIsToOpen(false)}
                                    inputFormat="MMM d, yyyy"
                                    onChange={(e) => setToDate(e)}
                                    disableFuture
                                    renderInput={(params) => {
                                        params.inputProps.value = CustomShortDateFormatter(toDate);

                                        return (
                                            <TextField
                                                className={classes.textField}
                                                {...params}
                                                helperText={""}
                                                placeholder={""}
                                                fullWidth
                                                InputLabelProps={{
                                                    style: { fontSize: "12px", fontFamily: "Arial", color: "rgba(0, 0, 0, 0.87)", fontWeight: "700" },
                                                }}
                                                error={false}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textField,
                                                    },
                                                    onClick: () => {
                                                        setIsToOpen(true);
                                                    },
                                                    onKeyDown: (e) => {
                                                        e.preventDefault();
                                                        return false;
                                                    },
                                                    endAdornment: (
                                                        <IconButton onClick={() => setIsToOpen(true)}>
                                                            <CalendarIcon />
                                                        </IconButton>
                                                    ),
                                                }}
                                            />
                                        );
                                    }}
                                />
                                {errorMessage && (
                                    <div className={classes.errorMessage}>
                                        {fromDate && toDate && fromDate > toDate ? intl.formatMessage(messages.creationDateMismatch) : null}
                                    </div>
                                )}
                            </div>
                        </div>
                    </SidebarAccordian>
                )}

                {/* Status */}
                {filtering && open && process.env.REACT_APP_FEATURE_MANAGELABOURERS === "true" && (
                    <SidebarAccordian
                        expanded={openStatus}
                        onChangeHandler={(e) => {
                            e.preventDefault();
                            setOpenStatus(!openStatus);
                        }}
                        required
                        headerTitle={messages.sidebarNavLinkAllStatusNameFilterTitle.id}>
                        <Filter
                            title={intl.formatMessage(messages.sidebarNavLinkAllStatusNameFilterTitle)}
                            filterOptions={allStatus}
                            filterKeys={{
                                name: getLocalizedName({ object: "name" }),
                            }}
                            inputFilter={allStatusList}
                            onUpdateFilter={(data) => handleUpdateFilterCall(data, "allStatus")}
                            isCleared={clearAllStatuses}
                            filterTitle="false"
                            titleKey={STATUS_KEY}
                            useAll={isAllSelectionAllowed}
                        />
                    </SidebarAccordian>
                )}

                {/* Zone */}
                {filtering && open && process.env.REACT_APP_FEATURE_MANAGELABOURERS === "true" && (
                    <SidebarAccordian
                        expanded={openZone}
                        onChangeHandler={(e) => {
                            e.preventDefault();
                            setOpenZone(!openZone);
                        }}
                        headerTitle={messages.sidebarNavLinkZoneFilterTitle.id}>
                        <FilterProperty
                            title={intl.formatMessage(messages.sidebarNavLinkZoneFilterTitle)}
                            filterOptions={zoneData}
                            inputFilter={zones}
                            onUpdateFilter={props.zonesSelected}
                            useAll
                        />
                    </SidebarAccordian>
                )}
                {/* Load and Clear */}
                {(contracts.length > 0 || allStatus.length > 0) && (
                    <div className={classes.btnStyle}>
                        <Button
                            padding={10}
                            variant="outlined"
                            color="primary"
                            onClick={fetchTasks}
                            disabled={isFetching || disableLoadButton || errorMessage}>
                            {intl.formatMessage(messages.sidebarNavLinkLoad)}
                        </Button>
                        &nbsp;
                        <Button padding={10} variant="outlined" color="primary" onClick={clearTasksCompletely}>
                            {intl.formatMessage(messages.sidebarNavLinkClear)}
                        </Button>
                    </div>
                )}
            </div>
        </Drawer>
    );
};
const mapStateToProps = (state) => ({
    open: state.dashboard.open,
    contracts: state.contracts,
    filter: state.dashboard.filter,
    task: state.tasks.tasks,
    zones: state.dashboard.zones,
    isFetching: state.tasks.fetching,
    allStatus: state.allStatus,
    state: state,
    dashboardStaus: state.dashboard.allstatus,
    dashboardcreationDateObject: state.dashboard.creationDate,
    dashboardState: state.dashboard,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setSidebar,
            filterDashboard,
            zonesSelected,
            requestTasks,
            allStatusDashboard,
            stopPolling,
            clearTasks,
            clearFilter,
            clearAllStatus,
            requestTasksSucceeded,
            getAllFiltersData,
            setCreationDate,
            clearCreationDate,
            filterTasklist,
            clearTaskCounts,
            clearWorkOrderId,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
